import { makeStyles } from 'tss-react/mui';

export default makeStyles<{ compact: boolean }>({ name: 'CustomerItem' })((_theme, { compact }) => ({
    root: {
        display: 'flex',
        width: 228,
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        ...(compact
            ? {
                  height: 54
              }
            : {
                  height: 120,
                  borderRadius: 24,
                  border: '1px solid #DEE1E2'
              })
    }
}));
